module.exports = __webpack_public_path__ + "img/christamma.ffed6d5c.jpg";